import script from "./ValidatePasswordReset.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatePasswordReset.vue?vue&type=script&setup=true&lang=js"

import "./ValidatePasswordReset.vue?vue&type=style&index=0&id=46a78454&scoped=true&lang=css"
import "./ValidatePasswordReset.vue?vue&type=style&index=1&id=46a78454&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a78454"]])

export default __exports__